export var EChatFlashMode;
(function (EChatFlashMode) {
    EChatFlashMode[EChatFlashMode["Always"] = 0] = "Always";
    EChatFlashMode[EChatFlashMode["Minimized"] = 1] = "Minimized";
    EChatFlashMode[EChatFlashMode["Never"] = 2] = "Never";
})(EChatFlashMode || (EChatFlashMode = {}));
